import styles from './SettingsSidebar.module.css';

const NAV_ITEMS = [
  { id: 'account',       label: 'Account',       icon: '👤' },
  // { id: 'privacy',       label: 'Privacy',        icon: '🔒' },
  { id: 'security',      label: 'Security',       icon: '🛡️' },
  { id: 'notifications', label: 'Notifications',  icon: '🔔' },
  // { id: 'display',       label: 'Display',        icon: '🎨' },
  { id: 'feedback',      label: 'Feedback',       icon: '💬' },
  {
    id: 'termsPrivacy',
    label: 'Terms & Privacy',
    icon: '📄',
  },
];

export default function SettingsSidebar({ activeSection, onSelect }) {
  return (
    <>
      {/* ── Desktop vertical sidebar ── */}
      <aside className={styles.sidebar}>
        <div className={styles.sectionLabel}>Settings</div>

        {NAV_ITEMS.map((item) => (
          <div
            key={item.id}
            className={`${styles.navItem} ${activeSection === item.id ? styles.active : ''}`}
            onClick={() => onSelect(item.id)}
          >
            <span className={styles.navIcon}>{item.icon}</span>
            <span className={styles.navLabel}>{item.label}</span>
          </div>
        ))}
      </aside>

      {/* ── Tablet horizontal pill-tabs ── */}
        <div className={styles.tabBar}>
          {NAV_ITEMS.map((item) => (
            <button
              key={item.id}
              className={`${styles.tabItem} ${activeSection === item.id ? styles.active : ''}`}
              onClick={() => onSelect(item.id)}
            >
              <span className={styles.tabIcon}>{item.icon}</span>
              {item.label}
            </button>
          ))}
        </div>

      {/* ── Mobile fixed bottom nav ── */}
      {/* <nav className={styles.mobileNav}>
        {NAV_ITEMS.map((item) => (
          <button
            key={item.id}
            className={`${styles.mobileNavItem} ${activeSection === item.id ? styles.active : ''}`}
            onClick={() => onSelect(item.id)}
          >
            <span className={styles.mobileNavIcon}>{item.icon}</span>
            <span className={styles.mobileNavLabel}>{item.label}</span>
          </button>
        ))}
      </nav> */}
    </>
  );
}